import React, { Fragment, useEffect, useState } from "react";

import { config } from "../../constant";
import useRequest from "../../../hooks/useRequest";
import { commonFunction } from "../../common-functions";
import { googleDriveMimeTypesToNormalMimeTypeMapping } from "../../../utils";

import ShowFileFolder from "./show-file-folders";

const GoogleDrive = (props) => {
  const {intl, callback, data, fileSelect, acceptedMime} = props;
  const {platform, data: selectedFolder} = data || {};

  const [loading, setLoading] = useState(false);
  const [folderData, setFolderData] = useState([]);
  const [folderPath, setFolderPath] = useState(["root"]);
  const [folderNameArr, setFolderNameArr] = useState(["root"]);
  const [folderId, setFolderID] = useState(selectedFolder || "root");
  const [showFolderPopup, setShowFolderPopup] = useState(false);

  const getFileUrl = `api/v1/google-drive/get-files?path=${folderId}`;
  const { 
    loading: fileLoading, 
    data: fileData,
    error: fileError,
    callAPI: getFileFolder,
    errorMessage: fileErrorMessage,
  } = useRequest(getFileUrl, false);
  useEffect(() => {
    if(!fileLoading && fileData){
      const {data} = fileData;
      const modifiedData = data.map(el => {
        const {id, mimeType: originalMimeType, modifiedDate, title} = el;
        const {
          mimeType, extension
        } = googleDriveMimeTypesToNormalMimeTypeMapping(originalMimeType);
        const name = extension && !title.includes(extension) ? `${title}${extension}` : title;
        const isFolder = mimeType === "application/vnd.google-apps.folder";

        return {
          id,
          name, 
          ...(!isFolder ? {
            file: {
              id,
              mimeType,
            }, 
          } : {}),
          folder: isFolder, 
          lastModifiedDateTime: modifiedDate
        }
      });
      setFolderData(modifiedData);
      setShowFolderPopup(true);
    }
  }, [fileLoading, fileData, fileSelect]);

  useEffect(() => {
    if(fileError && fileErrorMessage){
      commonFunction.showAlert(
        "Unable to fetch data, you might need to reauthenticate to allow access!",
        "error"
      );
    }
  }, [fileError, fileErrorMessage]);

  const openFolder = (el) => {
    setFolderPath(path => ([...path, el.id]));
    setFolderNameArr(path => ([...path, el.name]));
    setFolderID(el.id);
    setTimeout(() => {
      getFileFolder();
    });
  };

  return (
    <Fragment>
      <div className={`platform${platform === 'google-drive' ? ' selected' : ''}`}>
        <div className="flex-container vertical-middle">
          <div className="flexbox icon">
            <img className="max-width"   src={intl.icon} alt="icon"/>
          </div>
          <div className="flexbox name">
            {intl.name}
            {platform === 'google-drive' && folderId &&
              <span title={`Selected folder: ${folderId}`}>
                (Selected folder: {folderId})
              </span>
            }
          </div>
          <div className="flexbox button">
            <button 
              className="btn"
              onClick={() => {
                setLoading(true);
                getFileFolder();
              }}
              disabled={loading}
            >Select {fileSelect ? 'File' : 'Folder'}</button>
          </div>
        </div>
      </div>
      {showFolderPopup && 
        <ShowFileFolder
          acceptedMime={acceptedMime}
          fileSelect={fileSelect}
          loading={fileLoading}
          fileFolder={folderData}
          folderPath={folderNameArr[folderNameArr.length - 1]}
          open={openFolder}
          select={(data) => {
            if(data){
              if(data.id && !data.folder){
                const {id, name, file} = data;
                const { mimeType } = file;
                callback('google-drive', 
                  `${config.API_URL}api/v1/google-drive/download-file/${id}/?mimeType=${mimeType}&fileName=${name}`, 
                  {name, file, needHeader: true}
                );
                setShowFolderPopup(false);
                setLoading(false);
                return;
              }
              
              callback("google-drive", folderId);
              setShowFolderPopup(false);
              setLoading(false);
            }
          }}
          back={() => {
            if(folderPath.length <= 1){
              setLoading(false);
              setShowFolderPopup(false);
              return;
            }
            const path = [...folderPath];
            const folderNamePath = [...folderNameArr];
            path.pop();
            folderNamePath.pop();
            setFolderPath(path);
            setFolderNameArr(folderNamePath);
            setFolderID(path[path.length - 1]);
            setTimeout(() => {
              getFileFolder();
            });
          }}
          close={() => {
            setShowFolderPopup(false);
          }}
          type='google-drive'
      />
    }
    </Fragment>
  );
};

export default GoogleDrive;
